import React, { useRef } from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { Container, Section } from '@fiverr-private/layout_components';
import { MainContent } from '../MainContent';
import { Sidebar } from '../Sidebar';
import { ContactSellerModalWrapper } from '../ContactSellerModal';
import { MessageSellerButton } from '../MessageSellerButton';
import { CustomOrderModal } from '../CustomOrder';
import { StructuredData } from '../StructuredData';
import { wrClass } from './styles.ve.css';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the RolePage Component');
    logger.error(err, {
        cause: originalError,
    });
};

export const RolePage = () => {
    const sidebarThresholdRef = useRef<HTMLDivElement>(null);

    return (
        <ErrorBoundary onError={onRenderError}>
            <StructuredData />
            <Section className={wrClass}>
                <Container width="100%">
                    <MainContent sidebarThresholdRef={sidebarThresholdRef} />
                </Container>
                <Container height="100%">
                    <Sidebar sidebarThresholdRef={sidebarThresholdRef} />
                </Container>

                <ContactSellerModalWrapper />
                <CustomOrderModal />
                <MessageSellerButton />
            </Section>
        </ErrorBoundary>
    );
};
